<template>
    <div class="main-container">
        <HeaderElement />

        <div class="portfolio-details-wrapper section-space--pt_200">
            <div class="container">
                <template v-if="libary">
                    <div v-for="product in libary.products" :key="product.id" class="row section-space--ptb_30">
                        <div class="col-lg-12 section-space--mb_15">
                            <div class="portfolio-details-title">
                                <h3 class="portfolio-details-title ">{{ product.book_info.title }}</h3>
                            </div>
                        </div>
                        <div class="col-lg-8 order-2 order-lg-1">
                            <div class="portfolio-details-images">
                                <template v-if="0 < product.images.length">
                                    <img v-for="image in product.images" :key="image.id"
                                        class="img-fluid border-radus-5"
                                        :src="image ? image.image_path : require('../assets/img/no-image.jpeg')" alt="">
                                </template>
                                <div class="text" v-else>
                                    <p>Keine Produktbilder</p>
                                </div>
                            </div>
                            <div v-if="product.book_info && product.book_info.information" class="text mt-20">
                                <p><span class="font-bold">Allgemeine Info:</span> {{ product.book_info.information ||
                                    'Keine' }}</p>
                            </div>
                            <div v-if="product.characteristics" class="text mt-20">
                                <p><span class="font-bold">Beschreibung:</span> {{ product.characteristics || 'Keine' }}
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-4 order-1 order-lg-2">
                            <div class="portfolio-details-content">
                                <div class="portfolio-details-table">
                                    <table class="mb-0">
                                        <tbody>
                                            <tr class="portfolio-details-date">
                                                <td class="label">Stadt</td>
                                                <td>
                                                    {{ libary.city }}, {{ libary.country.name }}
                                                </td>
                                            </tr>

                                            <tr class="portfolio-details-date">
                                                <td class="label">Zustand</td>
                                                <td>
                                                    {{ bookConditionWording[product.condition] }}
                                                </td>
                                            </tr>

                                            <tr class="portfolio-details-date">
                                                <td class="label">Struktur</td>
                                                <td>
                                                    {{ libary.structure }}
                                                </td>
                                            </tr>

                                            <tr class="portfolio-details-client">
                                                <td class="label">Menge</td>
                                                <td>{{ product.quantity }}</td>
                                            </tr>

                                            <tr class="portfolio-details-tags">
                                                <td class="label">Limitierungsnummer</td>
                                                <td>{{ product.limit_number }}</td>
                                            </tr>

                                            <tr class="portfolio-details-tags">
                                                <td class="label">Kategorie</td>
                                                <td>{{ product.book_info.category.name }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <FooterMain />
        <OffCanvasMobileMenu />
    </div>
</template>

<script>
import HeaderElement from '@/components/HeaderElement'
import FooterMain from '@/components/FooterMain'
import { apiUrl } from '@/config.js'
import OffCanvasMobileMenu from '@/components/OffCanvasMobileMenu'

export default {
    name: 'SingleLibary',
    components: {
        HeaderElement,
        FooterMain,
        OffCanvasMobileMenu
    },
    data() {
        return {
            libary: null
        }
    },
    computed: {
        bookConditionWording() {
            return {
                1: 'Sehr schlecht',
                2: 'Schlecht',
                3: 'Gebrauchsspuren',
                4: 'Gut',
                5: 'Ausgezeichnet'
            }
        }
    },
    async mounted() {
        const data = await this.$axios.get(`${apiUrl}libaries/${this.$route.params.id}`)
        if (200 === data.status) {
            this.libary = data.data.user
        }
    },
}
</script>
